import { render, staticRenderFns } from "./TeamStatistics.vue?vue&type=template&id=37bab72e&"
import script from "./TeamStatistics.vue?vue&type=script&lang=js&"
export * from "./TeamStatistics.vue?vue&type=script&lang=js&"
import style0 from "./TeamStatistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports